import React, { useState, useEffect } from 'react';
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Paper, Avatar, Typography, Button, IconButton,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
    TextField, InputAdornment, Tooltip, Chip, Stack,
    CircularProgress, MenuItem, Select, FormControl, InputLabel, Grid,
    Pagination, Skeleton, Autocomplete, Drawer, Switch,
} from '@mui/material';
import { FaPlus as AddIcon, FaSearch as SearchIcon, FaEye } from 'react-icons/fa';
import { MdAddShoppingCart } from "react-icons/md";
import { MdDelete as DeleteIcon, MdEdit as EditIcon, MdDeleteForever } from 'react-icons/md';
import { FaEdit } from "react-icons/fa";
import { FiFilter as FilterIcon, FiRefreshCw as RefreshIcon } from 'react-icons/fi';
import ProductForm from '../../components/Products/ProductForm';
import { getData, postFileUpload, deleteData, putData, postData } from '../../Webservice/Webservice';
import { FaRegCheckCircle } from "react-icons/fa";
import { MdPresentToAll } from "react-icons/md";
import PRODUCT_ROUTES from '../../API_Route/ProductRoute';
import { API_URL } from '../../Utils/url';
import { useLocation, useNavigate } from 'react-router-dom';

const statusOptions = [
    { value: 'approved', label: 'approved', color: 'success' },
    { value: 'pending', label: 'pending', color: 'error' },
    { value: 'rejected', label: 'rejected', color: 'warning' },
];

const initialFormState = {
    title: "",
    description: "",
    key_features: "",
    how_to_use: "",
    category_id: "",
    subcategory_id: "",
    upc: "",
    product_images: [],
    unitType: "",
    unitValue: 0,
    unitName: "",
    status: "active",
    isPublished: false,
    brand: "",
    ideal_for: "",
    applied_for: "",
    container_type: "",
    country_of_orgin: "",
    color: "",
    createdBy: "",
    createdAt: "",
    gst: "",
    hsn_code: "",
    codAvailable: false,
    tags: [],
    b2c_mrp: '',
    b2c_discountType: '',
    b2c_discountValue: '',
    b2c_sellingPrice: '',
    b2b_discountType: '',
    b2b_discountValue: '',
    b2b_sellingPrice: '',
    visibility: ['b2b', 'b2c'],
    isFree: false,
    thresholdAmount: '',
    autoAdd: false,
    minimumStockQuantity: '',
    // Dimensions (UI uses flat fields; backend expects `dimensions` object)
    length: '',
    width: '',
    height: '',
    dimensionUnit: '',
    // Optional weight support
    weight: '',
    weightUnit: '',
    // New Fields
    slug: '',
    meta_title: '',
    meta_description: '',
    badge: '',
    is_featured: false,
    ingredients: '',
    skin_type: '',
    hair_type: '',
    fragrance_notes: '',
    is_vegan: false,
    cruelty_free: false,
    organic: false,
    shipping_class: '',
    return_policy: '',
    product_images: [],
    productVideos: []
};

const PAGE_SIZE = 20;

const ProductManagement = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [meta, setMeta] = useState({ page: 1, totalPages: 1, total: 0 });
    // State for UPC modal
    const [upcModalOpen, setUpcModalOpen] = useState(false);
    const [upcInput, setUpcInput] = useState('');
    const [upcVerifyResult, setUpcVerifyResult] = useState(null);
    const [upcResultModalOpen, setUpcResultModalOpen] = useState(false);
    const [upcVerifying, setUpcVerifying] = useState(false);
    // State for Request Form modal
    const [requestFormModalOpen, setRequestFormModalOpen] = useState(false);
    const [requestForm, setRequestForm] = useState({
        upc: '',
        maximumRetailPrice: '',
        b2c_sellingPrice: '',
        b2b_sellingPrice: ''
    });
    const [requestFormSubmitting, setRequestFormSubmitting] = useState(false);
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [categoryFilter, setCategoryFilter] = useState('all');
    const [subcategoryFilter, setSubcategoryFilter] = useState('all');
    const [isPublishedFilter, setIsPublishedFilter] = useState('all');
    const [stockStatusFilter, setStockStatusFilter] = useState('all');
    const [upcFilter, setUpcFilter] = useState('');
    const [hsnCodeFilter, setHsnCodeFilter] = useState('');
    const [showAddForm, setShowAddForm] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const [form, setForm] = useState(initialFormState);
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [editingProduct, setEditingProduct] = useState(null);
    const [formMode, setFormMode] = useState('edit');
    const [stockDialogOpen, setStockDialogOpen] = useState(false);
    const [selectedProductStock, setSelectedProductStock] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [warehouseList, setWarehouseList] = useState([]);
    const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
    const [ownershipFilter, setOwnershipFilter] = useState('all');
    const [brandFilter, setBrandFilter] = useState('');
    const [sortBy, setSortBy] = useState('createdAt');
    const [sortOrder, setSortOrder] = useState('desc');
    const [importModalOpen, setImportModalOpen] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [importing, setImporting] = useState(false);
    const [importErrors, setImportErrors] = useState([]);
    const [tempFilters, setTempFilters] = useState({
        searchTerm: searchTerm,
        statusFilter: statusFilter,
        statusFilter: statusFilter,
        categoryFilter: categoryFilter,
        subcategoryFilter: subcategoryFilter,
        isPublishedFilter: isPublishedFilter,
        stockStatusFilter: stockStatusFilter,
        upcFilter: upcFilter,
        hsnCodeFilter: hsnCodeFilter,
        ownershipFilter: ownershipFilter,
    });
    const [filterSubcategories, setFilterSubcategories] = useState([]);

    const [allProducts, setAllProducts] = useState([]);

    const fetchProducts = async () => {
        setLoading(true);
        try {
            const tokenValue = sessionStorage.getItem('token');
            const token = tokenValue ? `Bearer ${tokenValue}` : '';
            const params = {
                page: meta.page,
                limit: PAGE_SIZE,
                ...(searchTerm && { title: searchTerm }),
                ...(brandFilter && { brand: brandFilter }),
                ...(upcFilter && { upc: upcFilter }),
                ...(hsnCodeFilter && { hsnCode: hsnCodeFilter }),
                ...(statusFilter && statusFilter !== 'all' && { status: statusFilter }),
                ...(categoryFilter && categoryFilter !== 'all' && { categoryId: categoryFilter }),
                ...(subcategoryFilter && subcategoryFilter !== 'all' && { subcategoryId: subcategoryFilter }),
                ...(isPublishedFilter && isPublishedFilter !== 'all' && { isPublished: isPublishedFilter === 'true' }),
                ...(stockStatusFilter && stockStatusFilter !== 'all' && { stockStatus: stockStatusFilter }),
                ...(ownershipFilter && ownershipFilter !== 'all' && {
                    ownership: ownershipFilter === 'own' ? 'Own Product' :
                        ownershipFilter === 'vendor' ? 'Vendor Product' : ownershipFilter
                })
            };
            const response = await getData(PRODUCT_ROUTES.GET_PRODUCT, params, token, false);
            let productsArray = Array.isArray(response?.products)
                ? response.products
                : Array.isArray(response)
                    ? response
                    : (response.data || []);


            setAllProducts(productsArray);
            setFilteredProducts(productsArray);

            if (response?.meta) {
                setMeta(prev => ({
                    ...prev,
                    totalPages: response.meta.totalPages || Math.ceil((response.meta.total || productsArray.length) / PAGE_SIZE),
                    total: response.meta.total || productsArray.length,
                    page: response.meta.page ? Number(response.meta.page) : prev.page
                }));
            } else if (response?.totalDocs) {
                // Fallback for some APIs that might return totalDocs at root
                setMeta(prev => ({
                    ...prev,
                    totalPages: response.totalPages || Math.ceil(response.totalDocs / PAGE_SIZE),
                    total: response.totalDocs,
                }));
            } else {
                // Fallback if no specific meta, assume simple list (which might be wrong for pagination but better than 0)
                // This handles the case where maybe the API just returns a list and no pagination info
                const total = response?.total || productsArray.length; // Attempt to find total
                setMeta(prev => ({
                    ...prev,
                    // If we have just a list and no total, we can only assume 1 page or derived from count if we knew it was a full list
                    // But here we requested Limit 20. If we got 20, we don't know if there are more unless backend tells us.
                    totalPages: prev.totalPages || 1,
                    total: total
                }));
            }

        } catch (error) {
            console.error('Fetch products failed:', error);
            setMeta({ page: 1, totalPages: 1, total: 0 });
        } finally {
            setLoading(false);
        }
    };

    const fetchCategories = async () => {
        try {
            const tokenValue = sessionStorage.getItem('token');
            const token = tokenValue ? `Bearer ${tokenValue}` : '';
            const response = await getData('categories/list?limit=1000', null, token);
            setCategories(Array.isArray(response.categories) ? response.categories : []);
        } catch (error) {
            console.error('Fetch categories failed:', error);
        }
    };

    const fetchWarehouses = async () => {
        try {
            const tokenValue = sessionStorage.getItem('token');
            const token = tokenValue ? `Bearer ${tokenValue}` : '';
            const data = await getData('warehouse/list', null, token, false);
            setWarehouseList(data?.warehouse || []);
        } catch (error) {
            setWarehouseList([]);
        }
    };

    useEffect(() => {
        fetchProducts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [meta.page, searchTerm, upcFilter, hsnCodeFilter, statusFilter, categoryFilter, subcategoryFilter, isPublishedFilter, stockStatusFilter, ownershipFilter, brandFilter, sortBy, sortOrder]);



    useEffect(() => {
        fetchCategories();
        fetchWarehouses();
    }, []);

    // Sync state with URL query parameters
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const status = queryParams.get('status') || 'all';
        const category = queryParams.get('categoryId') || queryParams.get('category') || 'all';
        const subcategory = queryParams.get('subcategoryId') || 'all';
        const isPublished = queryParams.get('isPublished') || 'all';
        const stockStatus = queryParams.get('stockStatus') || 'all';
        const ownership = queryParams.get('ownership') || 'all';
        const title = queryParams.get('title') || '';
        const upc = queryParams.get('upc') || '';
        const hsnCode = queryParams.get('hsnCode') || '';

        setStatusFilter(status);
        setCategoryFilter(category);
        setSubcategoryFilter(subcategory);
        setIsPublishedFilter(isPublished);
        setStockStatusFilter(stockStatus);
        setOwnershipFilter(ownership);
        setSearchTerm(title);
        setUpcFilter(upc);
        setHsnCodeFilter(hsnCode);

        // Also sync tempFilters so the drawer shows the correct values when opened
        setTempFilters(prev => ({
            ...prev,
            statusFilter: status,
            categoryFilter: category,
            subcategoryFilter: subcategory,
            isPublishedFilter: isPublished,
            stockStatusFilter: stockStatus,
            ownershipFilter: ownership,
            searchTerm: title,
            upcFilter: upc,
            hsnCodeFilter: hsnCode,
        }));
    }, [location.search]);

    const fetchSubcategories = async (categoryId = form.category_id) => {
        if (!categoryId) {
            setSubcategories([]);
            return;
        }
        try {
            const tokenValue = sessionStorage.getItem('token');
            const token = tokenValue ? `Bearer ${tokenValue}` : '';
            const response = await getData(`subcategories/list?limit=1000&category_id=${categoryId}`, null, token);
            setSubcategories(Array.isArray(response.subcategories) ? response.subcategories : []);
        } catch (error) {
            setSubcategories([]);
            console.error('Fetch subcategories failed:', error);
        }
    };

    useEffect(() => {
        fetchSubcategories();
    }, [form.category_id]);

    const fetchFilterSubcategories = async (categoryId) => {
        try {
            const tokenValue = sessionStorage.getItem('token');
            const token = tokenValue ? `Bearer ${tokenValue}` : '';
            let url = 'subcategories/list?limit=1000';
            if (categoryId && categoryId !== 'all') {
                url += `&category_id=${categoryId}`;
            }
            const response = await getData(url, null, token);
            setFilterSubcategories(Array.isArray(response.subcategories) ? response.subcategories : []);
        } catch (error) {
            setFilterSubcategories([]);
        }
    };

    useEffect(() => {
        fetchFilterSubcategories(categoryFilter);
    }, [categoryFilter]);

    const handleAddOrEditProduct = async () => {
        try {
            const tokenValue = sessionStorage.getItem('token');
            const userId = sessionStorage.getItem('userId');
            const token = tokenValue ? `Bearer ${tokenValue}` : '';
            const { createdBy, ...formWithoutCreatedBy } = form;
            const requiredFields = [
                'title', 'description', 'key_features', 'how_to_use', 'category_id', 'subcategory_id',
                'unitType', 'unitValue', 'status', 'ideal_for', 'container_type'
            ];
            if (form.unitType === 'weight') requiredFields.push('unitName');
            // if (!userId) {
            //     alert('User ID not found. Please log in again.');
            //     return;
            // }
            const missing = requiredFields.filter(f => !form[f]);
            if (missing.length > 0) {
                alert('Please fill all required fields: ' + missing.join(', '));
                return;
            }
            const formData = new FormData();
            // Define dimension fields to exclude from individual append
            const dimensionFields = ['length', 'width', 'height', 'dimensionUnit', 'weight', 'weightUnit'];

            Object.entries(formWithoutCreatedBy).forEach(([key, value]) => {
                if (key === 'product_images' && Array.isArray(value)) {
                    value.forEach((img, idx) => {
                        if (img instanceof File) {
                            if (img.type.startsWith('video/')) {
                                formData.append('productVideos', img);
                            } else {
                                formData.append('product_images', img);
                            }
                        } else if (typeof img === 'string' && img.startsWith('data:')) {
                            const arr = img.split(',');
                            const mime = arr[0].match(/:(.*?);/)[1];
                            const bstr = atob(arr[1]);
                            let n = bstr.length;
                            const u8arr = new Uint8Array(n);
                            while (n--) {
                                u8arr[n] = bstr.charCodeAt(n);
                            }
                            const blob = new Blob([u8arr], { type: mime });
                            const ext = mime.split('/')[1];
                            if (mime.startsWith('video/')) {
                                formData.append('productVideos', blob, `video_${idx}.${ext}`);
                            } else {
                                formData.append('product_images', blob, `file_${idx}.${ext}`);
                            }
                        } else if (typeof img === 'string' && !img.startsWith('data:')) {
                            // If it's a URL or path, check extension to decide correct field
                            const isVideo = /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(img);
                            if (isVideo) {
                                formData.append('productVideos', img);
                            } else {
                                formData.append('product_images', img);
                            }
                        }
                    });
                }

                // Ensure media fields are present even if empty (for update)
                if (key === 'product_images' && Array.isArray(value) && value.length === 0) {
                    formData.append('product_images', '');
                    formData.append('productVideos', '');
                } else if (dimensionFields.includes(key)) {
                    // Skip dimension fields - they'll be sent as a JSON object
                } else if (key === 'unitType') {
                    formData.append('unitType', String(value));
                } else if (key === 'gst') {
                    formData.append('gst', String(value));
                } else if (key !== 'product_images' && key !== 'dimensions' && key !== 'productVideos' && key !== 'productVideo' && key !== 'tags') {
                    formData.append(key, value);
                }
            });
            // Append tags as JSON array if present
            // Append tags as comma separated string
            // Append tags as comma separated string
            if (Array.isArray(form.tags)) {
                formData.set('tags', form.tags.join(','));
            }
            // Append visibility as comma separated string
            if (Array.isArray(form.visibility)) {
                formData.set('visibility', form.visibility.join(','));
            }
            // Append consolidated dimensions object expected by backend
            const dimensions = {
                length: form.length ? Number(form.length) : undefined,
                width: form.width ? Number(form.width) : undefined,
                height: form.height ? Number(form.height) : undefined,
                unit: form.dimensionUnit || undefined,
                weight: form.weight ? Number(form.weight) : undefined,
                weightUnit: form.weightUnit || undefined
            };
            // Remove undefined keys to keep payload clean
            Object.keys(dimensions).forEach(k => dimensions[k] === undefined && delete dimensions[k]);
            if (Object.keys(dimensions).length > 0) {
                formData.append('dimensions', JSON.stringify(dimensions));
            }
            formData.append('createdBy', userId);
            if (editingProduct) {
                await putData(`product/update/${editingProduct._id}`, formData, token);
            } else {
                await postFileUpload(PRODUCT_ROUTES.ADD_PRODUCT, formData, token);
            }
            setForm(initialFormState);
            setShowAddForm(false);
            setEditingProduct(null);
            fetchProducts();
        } catch (error) {
            console.error('Add/Edit product failed:', error);
        }
    };

    const handleChange = (e) => {
        let updatedForm = { ...form, [e.target.name]: e.target.value };

        // If B2C price fields or MRP change, recalculate B2C selling price
        if (
            ['b2c_mrp', 'b2c_discountType', 'b2c_discountValue'].includes(e.target.name)
        ) {
            const mrp = parseFloat(updatedForm.b2c_mrp) || 0;
            const b2cDiscountValue = parseFloat(updatedForm.b2c_discountValue) || 0;
            let b2cSellingPrice = mrp;
            if (updatedForm.b2c_discountType === 'flat') {
                b2cSellingPrice = Math.max(0, mrp - b2cDiscountValue);
            } else if (updatedForm.b2c_discountType === 'percentage') {
                b2cSellingPrice = Math.max(0, mrp - (mrp * Math.min(100, b2cDiscountValue) / 100));
            }
            updatedForm.b2c_sellingPrice = b2cSellingPrice.toFixed(0);
        }

        // If B2B price fields or MRP change, recalculate B2B selling price
        if (
            ['b2c_mrp', 'b2b_discountType', 'b2b_discountValue'].includes(e.target.name)
        ) {
            const mrp = parseFloat(updatedForm.b2c_mrp) || 0;
            const b2bDiscountValue = parseFloat(updatedForm.b2b_discountValue) || 0;
            let b2bSellingPrice = mrp;
            if (updatedForm.b2b_discountType === 'flat') {
                b2bSellingPrice = Math.max(0, mrp - b2bDiscountValue);
            } else if (updatedForm.b2b_discountType === 'percentage') {
                b2bSellingPrice = Math.max(0, mrp - (mrp * Math.min(100, b2bDiscountValue) / 100));
            }
            updatedForm.b2b_sellingPrice = b2bSellingPrice.toFixed(0);
        }

        // If GST is changed, ensure it's set in form.gst
        if (e.target.name === 'gst') {
            updatedForm.gst = e.target.value;
        }

        if (e.target.name === 'category_id') {
            updatedForm.subcategory_id = '';
        }

        setForm(updatedForm);
    };

    const handleRefresh = () => {
        fetchProducts();
        fetchCategories();
    };

    const handleDeleteClick = (product) => {
        setProductToDelete(product);
        setDeleteDialogOpen(true);
    };

    const handleConfirmDelete = async () => {
        if (productToDelete) {
            try {
                const tokenValue = sessionStorage.getItem('token');
                const token = tokenValue ? `Bearer ${tokenValue}` : '';
                await deleteData(`product/delete/${productToDelete._id}`, token);
                setDeleteDialogOpen(false);
                setProductToDelete(null);
                fetchProducts();
            } catch (error) {
                console.error('Delete product failed:', error);
            }
        }
    };

    const handleCloseDeleteDialog = () => {
        setDeleteDialogOpen(false);
        setProductToDelete(null);
    };

    const handleTogglePublished = async (product) => {
        try {
            const tokenValue = sessionStorage.getItem('token');
            const token = tokenValue ? `Bearer ${tokenValue}` : '';
            const newStatus = !product.isPublished;

            // Optimistically update the UI
            setFilteredProducts(prev => prev.map(p =>
                p._id === product._id ? { ...p, isPublished: newStatus } : p
            ));

            const formData = new FormData();
            formData.append('isPublished', newStatus);

            await putData(`product/update/${product._id}`, formData, token);
            // Optional: fetchProducts(); // if needed for ensuring consistency
        } catch (error) {
            console.error('Toggle published failed:', error);
            // Revert state if error
            fetchProducts();
        }
    };

    // Pagination handler
    const handlePageChange = (event, newPage) => {
        setMeta((prev) => ({ ...prev, page: newPage }));
    };

    const handleFormModeChange = () => {
        setFormMode(prevMode => prevMode === 'view' ? 'edit' : 'view');
    };

    const handleProductTitleClick = async (product) => {
        try {
            const tokenValue = sessionStorage.getItem('token');
            const token = tokenValue ? `Bearer ${tokenValue}` : '';
            const response = await getData(`stock/list`, null, token, true, '', true);
            const allStock = response?.stock || [];

            // Filter stock for this specific product
            const productStock = allStock.filter(stock =>
                stock.product_id?._id === product._id || stock.product_id === product._id
            );

            setSelectedProductStock(productStock);
            setSelectedProduct(product);
            setStockDialogOpen(true);
        } catch (error) {
            console.error('Fetch product stock failed:', error);
            setSelectedProductStock([]);
            setSelectedProduct(product);
            setStockDialogOpen(true);
        }
    };

    return (
        <Box sx={{ p: 1 }}>
            <Paper elevation={2} sx={{ p: 1, boxShadow: 'none', backgroundColor: '#f8fafc' }}>
                <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 3,
                            flexWrap: 'wrap',
                            gap: 2
                        }}>
                            <Typography variant="h3" mb={2} component="h1" sx={{

                                color: 'text.primary',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                fontFamily: 'Mulish, sans-serif',

                            }}>
                                Product Management
                                <Chip
                                    label={`${meta.total} ${meta.total === 1 ? 'Item' : 'Items'}`}
                                    size="small"
                                    sx={{
                                        backgroundColor: 'rgba(255, 209, 2, 0.2)',
                                        color: '#b39200',
                                        fontFamily: 'Mulish, sans-serif',
                                        fontWeight: '800',
                                        border: '1px solid rgba(255, 209, 2, 0.5)'
                                    }}
                                />
                            </Typography>

                            <Stack direction="row" spacing={2} alignItems="center">
                                {/* <Button
                                    variant="outlined"
                                    startIcon={<FilterIcon />}
                                    sx={{
                                        fontFamily: 'Mulish, sans-serif',
                                        borderRadius: '10px',
                                        color: '#4b5563',
                                        borderColor: '#e5e7eb',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        px: 2,
                                        '&:hover': {
                                            borderColor: '#d1d5db',
                                            backgroundColor: '#f9fafb'
                                        }
                                    }}
                                    onClick={() => {
                                        setTempFilters({
                                            searchTerm,
                                            statusFilter,
                                            categoryFilter,
                                            ownershipFilter: ownershipFilter,
                                        });
                                        setFilterDrawerOpen(true);
                                    }}
                                >
                                    Filters
                                </Button> */}
                                <Button
                                    variant="outlined"
                                    onClick={async () => {
                                        try {
                                            const token = sessionStorage.getItem('token');
                                            const response = await fetch(`${API_URL}product/export`, {
                                                headers: { 'Authorization': `Bearer ${token}` }
                                            });
                                            const blob = await response.blob();
                                            const url = window.URL.createObjectURL(blob);
                                            const a = document.createElement('a');
                                            a.href = url;
                                            a.download = "products_export.csv";
                                            document.body.appendChild(a);
                                            a.click();
                                            a.remove();
                                        } catch (err) {
                                            alert('Export failed: ' + err.message);
                                        }
                                    }}
                                    sx={{
                                        fontFamily: 'Mulish, sans-serif',
                                        borderRadius: '10px',
                                        color: '#4b5563',
                                        borderColor: '#e5e7eb',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        px: 2,
                                        '&:hover': {
                                            borderColor: '#d1d5db',
                                            backgroundColor: '#f9fafb'
                                        }
                                    }}
                                >
                                    Export
                                </Button>

                                <Button
                                    variant="outlined"
                                    onClick={() => setImportModalOpen(true)}
                                    sx={{
                                        fontFamily: 'Mulish, sans-serif',
                                        borderRadius: '10px',
                                        color: '#4b5563',
                                        borderColor: '#e5e7eb',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        px: 2,
                                        '&:hover': {
                                            borderColor: '#d1d5db',
                                            backgroundColor: '#f9fafb'
                                        }
                                    }}
                                >
                                    Import
                                </Button>
                                <Button
                                    variant="contained"
                                    startIcon={<MdAddShoppingCart />}
                                    onClick={() => {
                                        navigate('add');
                                    }}
                                    sx={{
                                        fontFamily: 'Mulish, sans-serif',
                                        background: 'rgb(255 209 2)',
                                        color: 'black',
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        fontSize: '0.9rem',
                                        px: 3,
                                        boxShadow: '0 4px 12px rgba(255, 209, 2, 0.3)',
                                        border: '1px solid black',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            background: 'rgb(255 209 2)',
                                            boxShadow: '0 6px 16px rgba(255, 209, 2, 0.4)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}
                                >
                                    Add Product
                                </Button>

                            </Stack>
                        </Box>



                    <>
                                <Paper elevation={0} sx={{ p: 2, mb: 2, border: '1px solid #e5e7eb', borderRadius: '12px', bgcolor: '#f9fafb' }}>
                                    <Grid container spacing={1.5} alignItems="center">
                                        <Grid item xs={12} sm={2.5}>
                                            <TextField
                                                label="Product Name"
                                                variant="outlined" size="small" fullWidth
                                                value={searchTerm}
                                                onChange={e => { setSearchTerm(e.target.value); setMeta(p => ({ ...p, page: 1 })); }}
                                                sx={{ bgcolor: 'white', borderRadius: 2 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <TextField
                                                label="Brand"
                                                variant="outlined" size="small" fullWidth
                                                value={brandFilter}
                                                onChange={e => { setBrandFilter(e.target.value); setMeta(p => ({ ...p, page: 1 })); }}
                                                sx={{ bgcolor: 'white', borderRadius: 2 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={1.5}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel>Category</InputLabel>
                                                <Select
                                                    value={categoryFilter}
                                                    onChange={e => { setCategoryFilter(e.target.value); setMeta(p => ({ ...p, page: 1 })); }}
                                                    label="Category" sx={{ bgcolor: 'white', borderRadius: 2 }}
                                                >
                                                    <MenuItem value="all">All</MenuItem>
                                                    {categories.map((cat) => (
                                                        <MenuItem key={cat._id} value={cat._id}>{cat.title}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={1.5}>
                                            <FormControl fullWidth size="small" disabled={categoryFilter === 'all'}>
                                                <InputLabel>Subcategory</InputLabel>
                                                <Select
                                                    value={subcategoryFilter}
                                                    onChange={e => { setSubcategoryFilter(e.target.value); setMeta(p => ({ ...p, page: 1 })); }}
                                                    label="Subcategory" sx={{ bgcolor: 'white', borderRadius: 2 }}
                                                >
                                                    <MenuItem value="all">All</MenuItem>
                                                    {filterSubcategories.map((sub) => (
                                                        <MenuItem key={sub._id} value={sub._id}>{sub.title}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={1.5}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel>Live</InputLabel>
                                                <Select
                                                    value={isPublishedFilter}
                                                    onChange={e => { setIsPublishedFilter(e.target.value); setMeta(p => ({ ...p, page: 1 })); }}
                                                    label="Live" sx={{ bgcolor: 'white', borderRadius: 2 }}
                                                >
                                                    <MenuItem value="all">All</MenuItem>
                                                    <MenuItem value="true">Yes</MenuItem>
                                                    <MenuItem value="false">No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={1.5}>
                                            <FormControl fullWidth size="small">
                                                <InputLabel>Status</InputLabel>
                                                <Select
                                                    value={statusFilter}
                                                    onChange={e => { setStatusFilter(e.target.value); setMeta(p => ({ ...p, page: 1 })); }}
                                                    label="Status" sx={{ bgcolor: 'white', borderRadius: 2 }}
                                                >
                                                    <MenuItem value="all">All</MenuItem>
                                                    <MenuItem value="approved">Approved</MenuItem>
                                                    <MenuItem value="pending">Pending</MenuItem>
                                                    <MenuItem value="rejected">Rejected</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={1}>
                                            <Button
                                                variant="text" size="small"
                                                onClick={() => {
                                                    setSearchTerm('');
                                                    setBrandFilter('');
                                                    setCategoryFilter('all');
                                                    setSubcategoryFilter('all');
                                                    setIsPublishedFilter('all');
                                                    setStatusFilter('all');
                                                    setMeta(p => ({ ...p, page: 1 }));
                                                }}
                                                sx={{ color: '#dc2626', textTransform: 'none', fontWeight: 600 }}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                                <TableContainer
                                    component={Paper}
                                    elevation={0}
                                    sx={{
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                        border: '1px solid #d3d3d3de',
                                    }}
                                >
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow sx={{
                                                '& th': {
                                                    backgroundColor: '#f8f9fa',
                                                    fontWeight: 800,
                                                    py: 2,
                                                    fontSize: '0.75rem',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.05em',
                                                    color: '#5c636a',
                                                    fontFamily: 'Mulish, sans-serif',
                                                    borderBottom: '2px solid #edeff1',
                                                }
                                            }}>
                                                <TableCell width="80px">Image</TableCell>
                                                <TableCell>Product Details</TableCell>
                                                <TableCell>Brand</TableCell>
                                                <TableCell align="center">MRP</TableCell>
                                                <TableCell align="center">A/Q</TableCell>
                                                <TableCell align="center">M/Q</TableCell>
                                                <TableCell>Category</TableCell>
                                                <TableCell align="center">Live</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell align="right">Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {loading ? (
                                                Array.from({ length: 6 }).map((_, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell>
                                                            <Skeleton variant="rounded" width={56} height={56} />
                                                        </TableCell>
                                                        <TableCell>
                                                            <Skeleton width="60%" />
                                                            <Skeleton width="40%" />
                                                        </TableCell>
                                                        <TableCell><Skeleton width={140} /></TableCell>
                                                        <TableCell><Skeleton width={60} /></TableCell>
                                                        <TableCell><Skeleton width={60} /></TableCell>
                                                        <TableCell>
                                                            <Skeleton width={160} />
                                                            <Skeleton width={120} />
                                                        </TableCell>
                                                        <TableCell><Skeleton width={60} /></TableCell>
                                                        <TableCell><Skeleton width={100} /></TableCell>
                                                        <TableCell><Skeleton width={80} /></TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                filteredProducts.length > 0 ? (
                                                    filteredProducts.map((product) => {
                                                        const imageUrl = product.product_images?.[0]
                                                            ? product.product_images[0].startsWith('http')
                                                                ? product.product_images[0]
                                                                : `${API_URL.replace(/\/api\/v1\/?$/, '')}${product.product_images[0]}`
                                                            : '/img/default-product.png';
                                                        const status = statusOptions.find(opt => opt.value === product.status) ||
                                                            { label: product.status || 'Unknown', color: 'default' };
                                                        return (
                                                            <TableRow
                                                                key={product._id}
                                                                hover
                                                                sx={{
                                                                    '&:hover': { backgroundColor: '#f9fafb' },
                                                                    transition: 'background-color 0.2s ease'
                                                                }}
                                                            >
                                                                <TableCell>
                                                                    <Avatar
                                                                        variant="rounded"
                                                                        src={imageUrl}
                                                                        alt={product.title}
                                                                        sx={{
                                                                            width: 50,
                                                                            height: 50,
                                                                            backgroundColor: '#f3f4f6',
                                                                            borderRadius: '10px',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                                                            border: '1px solid #e5e7eb'
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell
                                                                    // onClick={() => handleProductTitleClick(product)}
                                                                    sx={{ cursor: 'pointer' }}
                                                                >
                                                                    <Typography
                                                                        fontWeight={700}
                                                                        sx={{
                                                                            fontFamily: 'Mulish, sans-serif',
                                                                            fontSize: '0.95rem',
                                                                            color: '#1a1c1e',
                                                                            '&:hover': { color: '#0d47a1' }
                                                                        }}
                                                                    >
                                                                        {product.title}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{
                                                                            fontFamily: 'Mulish, sans-serif',
                                                                            color: '#6b7280',
                                                                            display: 'inline-block',
                                                                            backgroundColor: '#f3f4f6',
                                                                            px: 1,
                                                                            borderRadius: '4px',
                                                                            mt: 1,
                                                                            fontWeight: 600
                                                                        }}
                                                                    >
                                                                        GSIN: {product.gsin || 'N/A'}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{
                                                                            fontFamily: 'Mulish, sans-serif',
                                                                            color: '#6b7280',
                                                                            display: 'inline-block',
                                                                            backgroundColor: '#f3f4f6',
                                                                            px: 1,
                                                                            borderRadius: '4px',
                                                                            mt: 0.5,
                                                                            ml: 1,
                                                                            fontWeight: 600
                                                                        }}
                                                                    >
                                                                        UPC: {product.upc || 'N/A'}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Typography
                                                                        fontWeight={500}
                                                                        sx={{ fontFamily: 'Mulish, sans-serif', color: '#4b5563', fontSize: '0.9rem' }}
                                                                    >
                                                                        {product.brand || '-'}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <Typography
                                                                        fontWeight={700}
                                                                        sx={{ fontFamily: 'Mulish, sans-serif', color: '#374151', fontSize: '0.95rem' }}
                                                                    >
                                                                        {product.b2c_mrp ? `₹${product.b2c_mrp}` : '-'}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <Typography
                                                                        fontWeight={700}
                                                                        sx={{
                                                                            fontFamily: 'Mulish, sans-serif',
                                                                            color: product.availableQuantity <= (product.minimumStockQuantity || 0) ? '#dc2626' : '#059669',
                                                                            fontSize: '0.95rem'
                                                                        }}
                                                                    >
                                                                        {product.availableQuantity}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <Typography
                                                                        fontWeight={500}
                                                                        sx={{ fontFamily: 'Mulish, sans-serif', color: '#6b7280', fontSize: '0.9rem' }}
                                                                    >
                                                                        {product.minimumStockQuantity || 0}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Typography
                                                                        fontWeight={600}
                                                                        sx={{ fontFamily: 'Mulish, sans-serif', color: '#374151', fontSize: '0.85rem' }}
                                                                    >
                                                                        {product.category_id?.title || '-'}
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{ fontFamily: 'Mulish, sans-serif', color: '#9ca3af' }}
                                                                    >
                                                                        {product.subcategory_id?.title || ''}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    <Switch
                                                                        size="small"
                                                                        checked={!!product.isPublished}
                                                                        onChange={() => handleTogglePublished(product)}
                                                                        color="success"
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Chip
                                                                        label={status.label}
                                                                        size="small"
                                                                        sx={{
                                                                            fontFamily: 'Mulish, sans-serif',
                                                                            fontWeight: 700,
                                                                            fontSize: '0.65rem',
                                                                            textTransform: 'uppercase',
                                                                            borderRadius: '6px',
                                                                            backgroundColor: status.color === 'success' ? '#def7ec' : status.color === 'error' ? '#fde8e8' : status.color === 'warning' ? '#fef3c7' : '#f3f4f6',
                                                                            color: status.color === 'success' ? '#03543f' : status.color === 'error' ? '#9b1c1c' : status.color === 'warning' ? '#92400e' : '#4b5563',
                                                                            border: 'none'
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                                        <Tooltip title="View Product">
                                                                            <IconButton
                                                                                size="small"
                                                                                sx={{
                                                                                    color: '#2196f3',
                                                                                    backgroundColor: 'rgba(33, 150, 243, 0.1)',
                                                                                    '&:hover': { backgroundColor: 'rgba(33, 150, 243, 0.2)' },
                                                                                    borderRadius: '8px',
                                                                                    mr: 1
                                                                                }}
                                                                                onClick={() => navigate(`view/${product._id}`)}
                                                                            >
                                                                                <FaEye />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        <Tooltip title="Edit Product">
                                                                            <IconButton
                                                                                size="small"
                                                                                sx={{
                                                                                    color: '#4682B4',
                                                                                    backgroundColor: 'rgba(70, 130, 180, 0.1)',
                                                                                    '&:hover': { backgroundColor: 'rgba(70, 130, 180, 0.2)' },
                                                                                    borderRadius: '8px'
                                                                                }}
                                                                                onClick={() => navigate(`edit/${product._id}`)}
                                                                            >
                                                                                <FaEdit />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        <Tooltip title="Delete">
                                                                            <IconButton
                                                                                size="small"
                                                                                sx={{
                                                                                    color: '#dc2626',
                                                                                    backgroundColor: 'rgba(220, 38, 38, 0.1)',
                                                                                    '&:hover': { backgroundColor: 'rgba(220, 38, 38, 0.2)' },
                                                                                    borderRadius: '8px'
                                                                                }}
                                                                                onClick={() => handleDeleteClick(product)}
                                                                            >
                                                                                <MdDeleteForever size={20} />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </Stack>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={12} sx={{
                                                            textAlign: 'center',
                                                            py: 6,
                                                            color: 'text.secondary'
                                                        }}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                gap: 1
                                                            }}>
                                                                <img
                                                                    style={{ width: '200px', }}
                                                                    src='./img/nodata.png' alt='nodata' />
                                                                <Typography variant="body1">
                                                                    {searchTerm || statusFilter !== 'all' || categoryFilter !== 'all' || ownershipFilter !== 'all'
                                                                        ? 'No products match your filters'
                                                                        : 'No products available'}
                                                                </Typography>
                                                                <Button
                                                                    variant="text"
                                                                    onClick={() => {
                                                                        setTempFilters({
                                                                            searchTerm: '',
                                                                            statusFilter: 'all',
                                                                            categoryFilter: 'all',
                                                                            subcategoryFilter: 'all',
                                                                            isPublishedFilter: 'all',
                                                                            stockStatusFilter: 'all',
                                                                            upcFilter: '',
                                                                            hsnCodeFilter: '',
                                                                            ownershipFilter: 'all',
                                                                        });
                                                                        setSearchTerm('');
                                                                        setUpcFilter('');
                                                                        setHsnCodeFilter('');
                                                                        setStatusFilter('all');
                                                                        setCategoryFilter('all');
                                                                        setSubcategoryFilter('all');
                                                                        setIsPublishedFilter('all');
                                                                        setStockStatusFilter('all');
                                                                        setOwnershipFilter('all'); setBrandFilter(''); setSortBy('createdAt'); setSortOrder('desc');
                                                                        setMeta(prev => ({ ...prev, page: 1 }));
                                                                        setFilterDrawerOpen(false);
                                                                    }}
                                                                >
                                                                    Clear filters
                                                                </Button>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {/* Pagination Component (centered, like Categories/ActivityLog) */}
                                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, '& .MuiPagination-ul': { flexWrap: 'nowrap' } }}>
                                    <Pagination
                                        count={meta.totalPages}
                                        page={meta.page}
                                        onChange={handlePageChange}
                                        sx={{
                                            '& .MuiPaginationItem-root': {
                                                fontFamily: 'Mulish, sans-serif',
                                                fontWeight: 600,
                                                borderRadius: '8px',
                                                '&.Mui-selected': {
                                                    backgroundColor: 'rgb(255, 209, 2)',
                                                    color: 'black',
                                                    '&:hover': {
                                                        backgroundColor: 'rgb(255, 190, 0)',
                                                    }
                                                }
                                            }
                                        }}
                                        shape="rounded"
                                        showFirstButton
                                        showLastButton
                                    />
                                </Box>
                                {meta.total > 0 && (
                                    <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block', textAlign: 'center' }}>
                                        Showing {(meta.page - 1) * PAGE_SIZE + 1} to {Math.min(meta.page * PAGE_SIZE, meta.total)} of {meta.total} entries
                                    </Typography>
                                )}
                                {loading && filteredProducts.length > 0 && (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                                        <CircularProgress size={24} />
                                    </Box>
                                )}
                            </>
                <Dialog
                    open={deleteDialogOpen}
                    onClose={handleCloseDeleteDialog}
                    PaperProps={{
                        style: {
                            borderRadius: '10px',
                            padding: '20px',
                            minWidth: '400px'
                        }
                    }}
                >
                    <DialogTitle sx={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>
                        <img style={{ width: '80px' }} src='./img/del1.png' alt='delete' />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText sx={{ textAlign: 'center', fontSize: '16px', mb: 1 }}>
                            Are you sure you want to delete product <b>"{productToDelete?.title}"</b> and all its variants?
                        </DialogContentText>
                        <Box sx={{
                            textAlign: 'center',
                            backgroundColor: '#fff3cd',
                            padding: '12px',
                            borderRadius: '4px',
                            borderLeft: '4px solid #ffc107',
                            marginBottom: '2px'
                        }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#856404', marginBottom: '3px' }}>
                                Warning
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#856404' }}>
                                By deleting, you won't be able to access it again.
                            </Typography>
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'center', gap: '20px', padding: '20px' }}>
                        <Button
                            onClick={handleCloseDeleteDialog}
                            variant="outlined"
                            sx={{
                                minWidth: '120px',
                                borderColor: 'gray',
                                color: 'gray',
                                '&:hover': {
                                    borderColor: 'darkgray',
                                    backgroundColor: 'rgba(0,0,0,0.05)'
                                }
                            }}
                        >
                            No, Cancel
                        </Button>
                        <Button
                            onClick={handleConfirmDelete}
                            variant="contained"
                            sx={{
                                minWidth: '120px',
                                backgroundColor: 'red',
                                '&:hover': {
                                    backgroundColor: '#bb2d3b'
                                }
                            }}
                            autoFocus
                        >
                            Yes, Delete
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* <Dialog 
                    open={stockDialogOpen} 
                    onClose={() => setStockDialogOpen(false)} 
                    maxWidth="lg" 
                    fullWidth
                >
                    <DialogTitle>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="h6" sx={{fontFamily:'Mulish, sans-serif',}}>
                                Stock Details for: {selectedProduct?.title}
                            </Typography>
                            <Button 
                                onClick={() => setStockDialogOpen(false)}
                                sx={{ color: 'red' }}
                            >
                                Close
                            </Button>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        {selectedProductStock.length > 0 ? (
                            <TableContainer component={Paper} sx={{ mt: 2 }}>
                                <Table>
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: 'rgb(255 209 2)' }}>
                                            <TableCell sx={{ fontWeight: 'bold', fontFamily:'Mulish, sans-serif', fontSize: 16, color: 'text.secondary' }}>Batch No</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontFamily:'Mulish, sans-serif', fontSize: 16, color: 'text.secondary' }}>Warehouse</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontFamily:'Mulish, sans-serif', fontSize: 16, color: 'text.secondary' }}>Quantity</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontFamily:'Mulish, sans-serif', fontSize: 16, color: 'text.secondary' }}>MRP</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontFamily:'Mulish, sans-serif', fontSize: 16, color: 'text.secondary' }}>Selling Price</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontFamily:'Mulish, sans-serif', fontSize: 16, color: 'text.secondary' }}>Purchase Price</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontFamily:'Mulish, sans-serif', fontSize: 16, color: 'text.secondary' }}>Manufacture Date</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', fontFamily:'Mulish, sans-serif', fontSize: 16, color: 'text.secondary' }}>Expire Date</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedProductStock.map((stock, index) => {
                                            const warehouseObj = warehouseList.find(w => w._id === stock.warehouseId);
                                            const warehouseName = warehouseObj ? warehouseObj.name : stock.warehouseId;
                                            
                                            return (
                                                <TableRow key={stock._id || index} hover>
                                                    <TableCell sx={{fontFamily:'Mulish, sans-serif'}}>{stock.batch_no}</TableCell>
                                                    <TableCell sx={{fontFamily:'Mulish, sans-serif'}}>{warehouseName}</TableCell>
                                                    <TableCell sx={{fontFamily:'Mulish, sans-serif'}}>{stock.quantity}</TableCell>
                                                    <TableCell sx={{fontFamily:'Mulish, sans-serif'}}>{stock.maximumRetailPrice}</TableCell>
                                                    <TableCell sx={{fontFamily:'Mulish, sans-serif'}}>{stock.sellingPrice}</TableCell>
                                                    <TableCell sx={{fontFamily:'Mulish, sans-serif'}}>{stock.purchasePrice}</TableCell>
                                                    <TableCell sx={{fontFamily:'Mulish, sans-serif'}}>
                                                        {stock.manufactureDate ? stock.manufactureDate.slice(0, 10) : ''}
                                                    </TableCell>
                                                    <TableCell sx={{fontFamily:'Mulish, sans-serif'}}>
                                                        {stock.expireDate ? stock.expireDate.slice(0, 10) : ''}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Box sx={{ 
                                textAlign: 'center', 
                                py: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 2
                            }}>
                                <img
                                    style={{ width: '150px' }}
                                    src='./img/nodata.png' 
                                    alt='no stock data' 
                                />
                                <Typography variant="h6" sx={{fontFamily:'Mulish, sans-serif'}}>
                                    No stock available for this product
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{fontFamily:'Mulish, sans-serif'}}>
                                    This product doesn't have any stock entries yet.
                                </Typography>
                            </Box>
                        )}
                    </DialogContent>
                </Dialog> */}
            </Paper>

            <Drawer
                anchor="right"
                open={filterDrawerOpen}
                onClose={() => setFilterDrawerOpen(false)}
            >
                <Box sx={{ width: 350, p: 3 }}>
                    <Typography variant="h6" sx={{ mb: 2, fontFamily: 'Mulish, sans-serif' }}>
                        Filters
                    </Typography>
                    <TextField
                        label="Title"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={tempFilters.searchTerm}
                        onChange={e => setTempFilters({ ...tempFilters, searchTerm: e.target.value })}
                        sx={{ mb: 2, borderRadius: 2 }}
                    />
                    <TextField
                        label="UPC"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={tempFilters.upcFilter}
                        onChange={e => setTempFilters({ ...tempFilters, upcFilter: e.target.value })}
                        sx={{ mb: 2, borderRadius: 2 }}
                    />
                    <TextField
                        label="HSN Code"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={tempFilters.hsnCodeFilter}
                        onChange={e => setTempFilters({ ...tempFilters, hsnCodeFilter: e.target.value })}
                        sx={{ mb: 2, borderRadius: 2 }}
                    />
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel>Status</InputLabel>
                        <Select
                            value={tempFilters.statusFilter}
                            onChange={e => setTempFilters({ ...tempFilters, statusFilter: e.target.value })}
                            label="Status"
                            sx={{ borderRadius: 2 }}
                        >
                            <MenuItem value="all">All Statuses</MenuItem>
                            {statusOptions.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Autocomplete
                        options={Array.isArray(categories) ? categories : []}
                        getOptionLabel={option => option.title || ""}
                        value={
                            categories.find(cat => cat._id === tempFilters.categoryFilter) ||
                            (tempFilters.categoryFilter === "all" ? { _id: "all", title: "All Categories" } : null)
                        }
                        onChange={(event, newValue) => {
                            setTempFilters({ ...tempFilters, categoryFilter: newValue ? newValue._id : "all" });
                        }}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Category"
                                size="small"
                                fullWidth
                                placeholder="Search categories..."
                                sx={{ borderRadius: 2 }}
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option._id === value._id}
                        ListboxProps={{
                            style: { maxHeight: 144, overflow: 'auto' }
                        }}
                        PaperComponent={({ children }) => (
                            <Paper elevation={8} sx={{ marginTop: 1, borderRadius: 2 }}>
                                {children}
                            </Paper>
                        )}
                        noOptionsText="No categories found"
                        sx={{ mb: 2 }}
                    />

                    <Autocomplete
                        options={Array.isArray(filterSubcategories) ? filterSubcategories : []}
                        getOptionLabel={option => option.title || ""}
                        value={
                            filterSubcategories.find(sub => sub._id === tempFilters.subcategoryFilter) ||
                            (tempFilters.subcategoryFilter === "all" ? { _id: "all", title: "All Subcategories" } : null)
                        }
                        onChange={(event, newValue) => {
                            setTempFilters({ ...tempFilters, subcategoryFilter: newValue ? newValue._id : "all" });
                        }}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label="Sub Category"
                                size="small"
                                fullWidth
                                placeholder="Search sub categories..."
                                sx={{ borderRadius: 2 }}
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option._id === value._id}
                        ListboxProps={{
                            style: { maxHeight: 144, overflow: 'auto' }
                        }}
                        PaperComponent={({ children }) => (
                            <Paper elevation={8} sx={{ marginTop: 1, borderRadius: 2 }}>
                                {children}
                            </Paper>
                        )}
                        noOptionsText="No subcategories found"
                        sx={{ mb: 2 }}
                    />

                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel>Is Published</InputLabel>
                        <Select
                            value={tempFilters.isPublishedFilter}
                            onChange={e => setTempFilters({ ...tempFilters, isPublishedFilter: e.target.value })}
                            label="Is Published"
                            sx={{ borderRadius: 2 }}
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="true">Yes</MenuItem>
                            <MenuItem value="false">No</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel>Stock Status</InputLabel>
                        <Select
                            value={tempFilters.stockStatusFilter}
                            onChange={e => setTempFilters({ ...tempFilters, stockStatusFilter: e.target.value })}
                            label="Stock Status"
                            sx={{ borderRadius: 2 }}
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="in_stock">In Stock</MenuItem>
                            <MenuItem value="out_of_stock">Out of Stock</MenuItem>
                            <MenuItem value="low_stock">Low Stock</MenuItem>
                        </Select>
                    </FormControl>

                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={() => {
                            setTempFilters({
                                searchTerm: '',
                                statusFilter: 'all',
                                categoryFilter: 'all',
                                subcategoryFilter: 'all',
                                isPublishedFilter: 'all',
                                stockStatusFilter: 'all',
                                upcFilter: '',
                                hsnCodeFilter: '',
                                ownershipFilter: 'all',
                            });
                            setSearchTerm('');
                            setUpcFilter('');
                            setHsnCodeFilter('');
                            setStatusFilter('all');
                            setCategoryFilter('all');
                            setSubcategoryFilter('all');
                            setIsPublishedFilter('all');
                            setStockStatusFilter('all');
                            setOwnershipFilter('all');
                            setMeta(prev => ({ ...prev, page: 1 }));
                            setFilterDrawerOpen(false);
                        }}
                        sx={{
                            fontFamily: 'Mulish, sans-serif',
                            borderRadius: '10px',
                            mt: 1,
                            color: '#4b5563',
                            borderColor: '#e5e7eb',
                            textTransform: 'none',
                            fontWeight: 600,
                            '&:hover': {
                                borderColor: '#d1d5db',
                                backgroundColor: '#f9fafb'
                            }
                        }}
                    >
                        Clear Filters
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        // color="primary"
                        onClick={() => {
                            let changed = false;
                            if (searchTerm !== tempFilters.searchTerm) {
                                setSearchTerm(tempFilters.searchTerm);
                                changed = true;
                            }
                            if (upcFilter !== tempFilters.upcFilter) {
                                setUpcFilter(tempFilters.upcFilter);
                                changed = true;
                            }
                            if (hsnCodeFilter !== tempFilters.hsnCodeFilter) {
                                setHsnCodeFilter(tempFilters.hsnCodeFilter);
                                changed = true;
                            }
                            if (statusFilter !== tempFilters.statusFilter) {
                                setStatusFilter(tempFilters.statusFilter);
                                changed = true;
                            }
                            if (categoryFilter !== tempFilters.categoryFilter) {
                                setCategoryFilter(tempFilters.categoryFilter);
                                changed = true;
                            }
                            if (subcategoryFilter !== tempFilters.subcategoryFilter) {
                                setSubcategoryFilter(tempFilters.subcategoryFilter);
                                changed = true;
                            }
                            if (isPublishedFilter !== tempFilters.isPublishedFilter) {
                                setIsPublishedFilter(tempFilters.isPublishedFilter);
                                changed = true;
                            }
                            if (stockStatusFilter !== tempFilters.stockStatusFilter) {
                                setStockStatusFilter(tempFilters.stockStatusFilter);
                                changed = true;
                            }
                            if (ownershipFilter !== tempFilters.ownershipFilter) {
                                setOwnershipFilter(tempFilters.ownershipFilter);
                                changed = true;
                            }
                            // Always reset to first page, which will trigger useEffect
                            setMeta(prev => ({ ...prev, page: 1 }));
                            setFilterDrawerOpen(false);
                        }}
                        sx={{
                            fontFamily: 'Mulish, sans-serif',
                            borderRadius: '10px',
                            mt: 2,
                            background: 'rgb(255 209 2)',
                            color: 'black',
                            textTransform: 'none',
                            fontWeight: 700,
                            fontSize: '0.95rem',
                            boxShadow: '0 4px 12px rgba(255, 209, 2, 0.3)',
                            border: '1px solid black',
                            '&:hover': {
                                background: 'rgb(255 209 2)',
                                boxShadow: '0 6px 16px rgba(255, 209, 2, 0.4)',
                                transform: 'translateY(-1px)'
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Apply Filters
                    </Button>
                </Box>
            </Drawer>

            {/* Import Dialog */}
            <Dialog open={importModalOpen} onClose={() => { setImportModalOpen(false); setImportErrors([]); setImportFile(null); }} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ fontWeight: 800 }}>Import Products</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Upload an .xlsx file containing product data to carry out bulk creation (helps with dropdown selections).
                        You may download a template matching expected headers setup beneath:
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={async () => {
                            const token = sessionStorage.getItem('token');
                            const response = await fetch(`${API_URL}product/template`, {
                                headers: { 'Authorization': `Bearer ${token}` }
                            });
                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = "products_template.xlsx";
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                        }}
                        sx={{ mb: 2 }}
                    >
                        Download Template
                    </Button>
                    <Box mt={2}>
                        <input
                            type="file"
                            accept=".csv, .xlsx"
                            onChange={(e) => setImportFile(e.target.files[0])}
                            style={{ display: 'block', marginBottom: '10px' }}
                        />
                    </Box>

                    {importErrors.length > 0 && (
                        <Box mt={2} p={2} sx={{ bgcolor: '#fff1f1', border: '1px solid #ff4d4d', borderRadius: 2 }}>
                            <Typography variant="subtitle2" color="#ff4d4d" fontWeight="bold">Errors found in file:</Typography>
                            <ul style={{ margin: 0, paddingLeft: '20px', color: '#ff4d4d' }}>
                                {importErrors.map((err, idx) => <li key={idx}><Typography variant="caption">{err}</Typography></li>)}
                            </ul>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setImportModalOpen(false); setImportErrors([]); setImportFile(null); }}>Cancel</Button>
                    <Button
                        variant="contained"
                        disabled={!importFile || importing}
                        onClick={async () => {
                            setImporting(true);
                            setImportErrors([]);
                            try {
                                const formData = new FormData();
                                formData.append('file', importFile);
                                const token = sessionStorage.getItem('token');
                                const response = await fetch(`${API_URL}product/import`, {
                                    method: 'POST',
                                    headers: { 'Authorization': `Bearer ${token}` },
                                    body: formData
                                });
                                const result = await response.json();
                                if (response.status === 207 || !result.success) {
                                    setImportErrors(result.errors || [result.message]);
                                } else if (response.ok) {
                                    alert('Products imported successfully!');
                                    setImportModalOpen(false);
                                    setImportFile(null);
                                    window.location.reload(); // Refresh to see products
                                }
                            } catch (err) {
                                alert('Import failed: ' + err.message);
                            } finally {
                                setImporting(false);
                            }
                        }}
                        sx={{ background: 'rgb(255 209 2)', color: 'black' }}
                    >
                        {importing ? <CircularProgress size={24} /> : 'Upload'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ProductManagement;